import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    getFileDownloadHeaders,
    handleQueryError,
} from "../../../helpers/utils/RtkQueryUtils";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
import {downloadFile, openFileInNewTab} from "../../../helpers/utils/FileUtils";

export const reportHistoryApi = tgxApi.injectEndpoints({
    endpoints: (build) => ({
        searchReportHistoryApi: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `/ajax/report-history?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['reportHistory'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        getReportHistoryApiById: build.query({
            query: (id) => {
                return {
                    url: `/ajax/get-association-by-id/${id}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['reportHistoryById'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        exportReportHistoryApiData: build.query({
            query: (query) => {
                return {
                    url: `/export/association?`,
                    method: 'GET',
                    params: query,
                    headers: getFileDownloadHeaders(),
                    responseType: 'arraybuffer',
                    responseHandler: async (response: { blob: () => any; }) => {
                        const blob = await response.blob();
                        downloadFile(blob, getFileName("appraisal rolls"))
                        return {success: true};
                    },
                };
            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
        downloadReportHistoryFiles: build.query({
            query: (fileId) => {
                return {
                    url: `/ajax/download-report-file/${fileId}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                    responseHandler: async (response: any) => {
                        const blob = await response.blob();

                        const contentDisposition = response.headers.get('Content-Disposition');
                        const filename = contentDisposition
                            ? contentDisposition.split('filename=')[1]
                            : `file_${fileId}.pdf`;

                        downloadFile(blob, filename);

                        return {success: true};
                    },
                };

            },
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),
    }),

});


export const {
    useSearchReportHistoryApiQuery,
    useLazyDownloadReportHistoryFilesQuery
} = reportHistoryApi;